import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { SaveGuiaRequest } from '@/types';
import * as api from './api';

export const guiaKeys = {
  all: ['guias'] as const,
  list: (mes: string) => ['guias', 'list', mes] as const,
  summary: (mes: string) => ['guias', 'summary', mes] as const,
};

export function useGuias(mes: string) {
  return useQuery({ queryKey: guiaKeys.list(mes), queryFn: () => api.listGuias(mes) });
}

export function useMonthSummary(mes: string) {
  return useQuery({ queryKey: guiaKeys.summary(mes), queryFn: () => api.getSummary(mes) });
}

export function useSaveGuia() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id?: string; body: SaveGuiaRequest }) =>
      id ? api.updateGuia(id, body) : api.createGuia(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: guiaKeys.all }),
  });
}

export function useDeleteGuia() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.deleteGuia(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: guiaKeys.all }),
  });
}

export function useClearDemo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.clearDemo(),
    onSuccess: () => qc.invalidateQueries({ queryKey: guiaKeys.all }),
  });
}
